<main class="c-main">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12"></div>
            <!-- ngFor for para percorrer o array de erros e se existir erros imprimir na tela -->
            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
                {{ erro }}
            </div>
        </div>
        <div class="mat-elevation-z8">
            <mat-card>
                <mat-card-title>
                    <mat-icon>color_lens</mat-icon>
                    Bairro
                </mat-card-title>
                <mat-tab-group mat-align-tabs="start" #tabGroup>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>add</mat-icon>
                            Cadastrar Bairro
                        </ng-template>
                        <!-- CADASATRANDO OBJETO INICIO -->
                        <mat-card>
                            <form [formGroup]="formulario" (ngSubmit)="submit()">
                                <!--passa qual é o formulario e o evento-->
                            <div class="row">
                                <div class="col-2">
                                    <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                        <mat-label>ID</mat-label>
                                        <input formControlName="id" matInput readonly>
                                    </mat-form-field>
                                </div>
                                <div class="col-10">
                                    <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                        <mat-label>Nome</mat-label>
                                        <input formControlName="name" matInput placeholder="Digite seu nome" minlength="3"
                                            maxlength="250" required>
                                    </mat-form-field>                             
                                </div>                                
                            </div>                            

                                <div class="row justify-content-between">
                                    <div class="col-6">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button (click)="limparFormulario()" mat-raised-button>
                                            <mat-icon>insert_drive_file</mat-icon>
                                            Limpar
                                        </button>
                                    </div>
                                    <div class="col-6" align="right">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button [disabled]="!formulario.valid" mat-raised-button color="primary">
                                            <mat-icon>save</mat-icon>
                                            Salvar
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <div class="esp-top">
                                <!-- verifica se tem erros no preenchimento do campo e se inicio o preenchimento -->
                                <div *ngIf="formulario.controls.name.errors && !formulario.controls.name.pristine"
                                    class="alert alert-warning" role="alert">
                                    Campo nome deve conter entre 3 e 250 caracteres!
                                </div>
                               
                            </div>
                        </mat-card>
                    </mat-tab>
                    <!-- CADASATRANDO OBJETO INICIO -->

                    <!-- LISTANDO TODAS INICIO -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>list</mat-icon>
                            Listar Bairros
                        </ng-template>
                        <mat-card>
                            <!-- //inicio da tabela -->
                                        <div class="row"> 
                                            <div class="col-4">                    
                                                    <mat-form-field appearance="fill" style="width: 100%;">
                                                        <mat-label>Consulta Por</mat-label>
                                                        <mat-select id="tipoFiltro" name="tipoFiltro" [(value)]="tipoFiltro" required>
                                                            <mat-option [value]="tipoFiltro" *ngFor="let tipoFiltro of tipoFiltros">{{tipoFiltro}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                            </div>
                                            <div class="col-6" *ngIf="tipoFiltro == 'Nome'">
                                                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                                    <mat-label>Nome</mat-label>
                                                    <input [(ngModel)]="parametroConsulta" name="parametroConsulta" matInput>
                                                </mat-form-field>
                                            </div>                                            

                                            <div class="col-2">
                                                        <button (click)="consultar()" mat-raised-button color="primary" style="line-height: 51px;width: 100%;">
                                                            <mat-icon>search</mat-icon>
                                                            Consultar
                                                        </button>                                        
                                            </div>

                                    </div>
                            <table mat-table [dataSource]="neighborhoods" class="full-width">
                                <!-- Coluna ID -->
                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef> ID </th>
                                    <td mat-cell *matCellDef="let neighborhood"> {{ neighborhood.id }} </td>
                                </ng-container>

                                <!-- Coluna Nome -->
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef> Nome </th>
                                    <td mat-cell *matCellDef="let neighborhood"> {{ neighborhood.name }} </td>
                                </ng-container>                            
                                                            

                                <ng-container matColumnDef="excluir">
                                    <th mat-header-cell *matHeaderCellDef> Excluir </th>
                                    <td mat-cell *matCellDef="let neighborhood">
                                        <button (click)="openDialog(neighborhood.id)" mat-icon-button color="warn">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="editar">
                                    <th mat-header-cell *matHeaderCellDef>Editar</th>
                                    <td mat-cell *matCellDef="let neighborhood">
                                        <button (click)="editar(neighborhood.id)" (click)="tabGroup.selectedIndex = 0"
                                            mat-icon-button color="accent">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>                                
                                <!-- definir como vai ser as linhas e a ordem das colunas -->
                                <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
                                <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
                            </table>

                            <!-- paginação -->
                            <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
                                [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
                                <!-- evento de paginar -->
                            </mat-paginator>

                        </mat-card>
                    </mat-tab>
                    <!-- LISTANDO TODAS FIM -->
                </mat-tab-group>
            </mat-card>
        </div>
    </div>

</main>